import { render } from "./MahtasMark.vue?vue&type=template&id=7cf4b6a0&scoped=true"
import script from "./MahtasMark.vue?vue&type=script&lang=js"
export * from "./MahtasMark.vue?vue&type=script&lang=js"

import "./MahtasMark.vue?vue&type=style&index=0&id=7cf4b6a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf4b6a0"]])

export default __exports__